import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IComponentSliderConfig, ISliderItem } from '../../models/slider.model';
import { ScreenSizeStoreService } from '../../services/scrren-size.service';
import { ScreenSize } from '../../models/screen-size.model';
import { HandsetService } from '../../../core/services/handset.service';


@Component({
standalone: false,
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  private _config: IComponentSliderConfig;
  private touchStartX = 0;
  public translateX = 0;
  currentTranslateX = 0;
  @Input()
  public stopOnLastSlide: boolean;

  @Input()
  public showSpinner: boolean;

  @Input()
  set config(value: IComponentSliderConfig) {
    this._config = value;
    if (value !== undefined) {
      this.images = value.items;
      this.image = this.images[0];
      this.interval = value.disabledAuto ? 0 : (value.interval ? value.interval : 10);
      this.preloadImage(this.imageUrl);
      this.setInterval();
    }
  }

  @Output()
  public lastSlideAction = new EventEmitter<boolean>();

  @Output()
  public loadedEvent = new EventEmitter<boolean>();

  public images: ISliderItem[] = [];
  public image: ISliderItem;
  public imageObject: any;
  public imageLoaded = false;
  private intervalId: any;
  private interval: number;
  public isMobile = false;

  constructor(private router: Router,
              public handsetService: HandsetService,
              private screenSizeStore: ScreenSizeStoreService) {
  }

  ngOnInit(): void {
    this.screenSizeStore.getState().subscribe(value => {
      this.isMobile = (ScreenSize.XS === value || ScreenSize.S === value);
    });
  }

  preloadImage(url: string) {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      this.imageLoaded = true;
      this.loadedEvent.emit(true);
    };
  }

  onSliderActionClick(url: ISliderItem) {
    this.router.navigateByUrl(url.actionUrl);
  }

  onSliderButtonClick(value: ISliderItem) {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.image = value;
    this.setInterval();
  }

  onGoNext() {
    let index = (this.images.findIndex(value => value.id === this.image.id) + 1) % this.images.length;
    let value = this.images[index];
    if (index === (this.images.length - 1)) {
      this.lastSlideAction.emit(true);
    }
    this.onSliderButtonClick(value);
  }

  onGoPrevious() {
    let index = this.images.findIndex(value => value.id === this.image.id);
    let value: ISliderItem;
    if (index === 0) {
      value = this.images[(this.images.length - 1)];
    } else {
      value = this.images[index - 1];
    }
    this.onSliderButtonClick(value);
  }

  private setInterval() {
    if (this.interval > 0) {
      let intervalInMs = this.interval * 1000;

      this.intervalId = setInterval(() => {
        let index = (this.images.findIndex(value => value.id === this.image.id) + 1) % this.images.length;
        this.image = this.images[index];
        if (this.stopOnLastSlide) {
          if (this.images.length === (index + 1)) {
            clearInterval(this.intervalId);
            this.lastSlideAction.emit(true);
          }
        }
      }, intervalInMs);
    }
  }

  get imageUrl() {
    if (this.isMobile && this.image.imgUrlForMobile !== undefined && this.image.imgUrlForMobile !== null) {
      return this.image.imgUrlForMobile;
    } else {
      return this.image.imgUrl;
    }
  }

  get config(): IComponentSliderConfig {
    return this._config;
  }

  get titleStyle() {
    if (!this.image) {
      return {};
    } else if (this.image.titleColor) {
      return {
        margin: 0,
        ...this.config.titleStyle,
        color: this.image.titleColor,
      };
    } else {
      return {
        margin: 0,
        ...this.config.titleStyle,
      };
    }
  }

  get subtitleStyle() {
    if (!this.image) {
      return {};
    } else if (this.image.subtitleColor) {
      return {
        ...this.config.subtitleStyle,
        color: this.image.subtitleColor,
      };
    } else {
      return this.config.subtitleStyle;
    }
  }

  get sliderStyle() {
    if (!this.config || !this.config.style) {
      return {};
    }
    return this.config.style;
  }

  get mobileSliderStyle() {
    if (!this.config || !this.config.style) {
      return {};
    }
    return this.config.style;
  }

  get imgStyle() {
    return this.config.imgStyle;
  }

  get buttonsStyle() {
    return this.config.buttonsStyle;
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.touches[0].clientX;
    this.currentTranslateX = this.translateX;
  }

  onTouchEnd(event: TouchEvent) {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchEndX - this.touchStartX;
    if (swipeDistance > 50) {
      this.onGoPrevious();
    } else if (swipeDistance < -50) {
      this.onGoNext();
    }
    this.updateTranslateX();
  }

  onTouchMove(event: TouchEvent) {
    const touchX = event.touches[0].clientX;
    const moveDistance = touchX - this.touchStartX;
    this.translateX = this.currentTranslateX + moveDistance;
  }

  updateTranslateX() {
    this.translateX = 0;
  }
}
